import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { PAGE_DATA_TYPES } from '../utils';
import { Button } from '../../components/widgets';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import css from './RequestIntegrationMessage.css';

// Rendered as the "no options" message inside the "Add Data Connector" dropdown when a
// search matches no existing integration. Clicking "Request this integration" opens the
// request form (owned by AddNewUan) — see RequestIntegrationForm.
const RequestIntegrationMessage = ({
    inputValue = '',
    translationPageKey = PAGE_DATA_TYPES.DATA_SOURCES,
    onRequestClick = () => {},
}) => {
    const name = (inputValue || '').trim();
    const prefix = `STATIC.PAGES.${translationPageKey}`;

    // With an empty query the dropdown always has options, so this is effectively unreachable.
    if (!name) {
        return null;
    }

    return (
        // Prevent the select input from blurring (which collapses the dropdown) before the click.
        <div className={css.noResults} onMouseDown={e => e.preventDefault()}>
            <Icon
                name="search-off"
                size={IconSizes.LARGE}
                variant={IconVariants.LIGHT}
                interactive={false}
                className={css.noResultsIcon}
            />
            <div className={css.noResultsTitle}>
                <Translate id={`${prefix}.REQUEST_INTEGRATION_NO_RESULTS_TITLE`} />
            </div>
            <div className={css.noResultsSubtitle}>
                <Translate id={`${prefix}.REQUEST_INTEGRATION_PROMPT`} data={{ name }} />
            </div>
            <Button
                type="primary"
                level="level1"
                text={`${prefix}.REQUEST_INTEGRATION_CTA`}
                className={css.requestButton}
                onClick={() => onRequestClick(name)}
            />
        </div>
    );
};

RequestIntegrationMessage.propTypes = {
    inputValue: PropTypes.string,
    translationPageKey: PropTypes.string,
    onRequestClick: PropTypes.func,
};

export default RequestIntegrationMessage;
